import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/common/close.png'
import _imports_1 from '@/assets/board/close_gray.png'
import _imports_2 from '@/assets/board/close_wh.png'


const _withScopeId = n => (_pushScopeId("data-v-9364ac98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_layer" }
const _hoisted_2 = { class: "modal_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal_content bg" }
const _hoisted_6 = { class: "keyword_modal" }
const _hoisted_7 = { class: "keyword_add" }
const _hoisted_8 = { class: "keyword_form" }
const _hoisted_9 = { class: "input_wrap" }
const _hoisted_10 = { class: "keyword_list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal_message" }, "설정한 키워드는 매일 19시 이후 자동 X에서 검색합니다.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "modal_bg",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.fnEvent(false)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 키워드 "),
        _createElementVNode("div", {
          class: "close_btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.fnEvent(false)))
        }, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "monitoring_btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.switchInput(true, $event)))
            }),
            _createElementVNode("form", _hoisted_8, [
              _withDirectives(_createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  class: "new_keyword",
                  ref: "keywordRef",
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.keyword.newData) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.addList && $setup.addList(...args))),
                  onInput: _cache[5] || (_cache[5] = ($event: any) => ($setup.checkText()))
                }, null, 544), [
                  [_vModelText, $setup.keyword.newData]
                ]),
                _createElementVNode("button", {
                  class: "remove_btn",
                  type: "button",
                  onMousedown: _cache[6] || (_cache[6] = ($event: any) => ($setup.state.inputBulr = true)),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.switchInput(false, $event)))
                }, null, 32)
              ], 512), [
                [_vShow, $setup.state.isNewKeyword]
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.keyword.list, (value, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["keyword", { active: value.state }])
              }, [
                _createElementVNode("button", {
                  class: "remove_btn",
                  type: "button",
                  onClick: ($event: any) => ($setup.changeActive(value.idx))
                }, [
                  _createTextVNode(_toDisplayString(value.keyword) + " ", 1),
                  (!value.state)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_1,
                        onClick: _withModifiers(($event: any) => ($setup.removeList(value.idx)), ["stop"])
                      }, null, 8, _hoisted_12))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_2,
                        onClick: _withModifiers(($event: any) => ($setup.removeList(value.idx)), ["stop"])
                      }, null, 8, _hoisted_13))
                ], 8, _hoisted_11)
              ], 2))
            }), 256))
          ])
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", {
        class: "modal_btn full",
        onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.fnEvent(true)))
      }, "확인")
    ])
  ], 64))
}